import { DownloadOutlined, FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import { Dropdown, Form, Select, Spin, Tag } from "antd";
import "leaflet/dist/leaflet.css";
import React, { useEffect, useRef, useState } from "react";
import { Chart } from "react-google-charts";
import { GeoJSON, MapContainer, TileLayer } from "react-leaflet";
import { useNavigate } from "react-router-dom";
import ReactToPrint from "react-to-print";
import { toast } from "react-toastify";
import { getRequest } from "../../api/http";
import userServiceApi from "../../api/userServiceApi";
import leftArrow from "../../assets/images/LeftArrow.svg";
import shareIcon from "../../assets/images/share-icon-copy.svg";
import Duration from "../duration-filter/duration";
import geoJsonData from "../super-admin/populationData.json";
import "./analytics.scss";


const options = {
  // region: "002", // Africa
  colorAxis: { colors: ["#0f97f2", "#065e99", "#04253b"] },
  // colorAxis: { colors: ["#0cf041", "078f27", "#033b10"] },
  backgroundColor: "#FFFFF",
  // backgroundColor: "#81d4fa",
  // datalessRegionColor: "#f8bbd0",

  // datalessRegionColor: '#81D4FA',
  defaultColor: "#f5f5f5",
  defaultColor: "#FFFFF",
  region: "GB", // ISO 3166-1 alpha-2 code for the United Kingdom
  displayMode: "regions",
  resolution: "provinces",
};

const options2 = {
  // region: "002", // Africa
  colorAxis: { colors: ["#0f97f2", "#065e99", "#04253b"] },
  // colorAxis: { colors: ["#0cf041", "078f27", "#033b10"] },
  backgroundColor: "#FFFFF",
  // backgroundColor: "#81d4fa",
  // datalessRegionColor: "#f8bbd0",

  // datalessRegionColor: '#81D4FA',
  defaultColor: "#f5f5f5",
  defaultColor: "#FFFFF",
  // region: 'GB', // ISO 3166-1 alpha-2 code for the United Kingdom
  // displayMode: 'regions',
  // resolution: 'provinces',
};

const BarChartOptions = {
  title: "No. of users based on province",
  // chartArea: { width: "50%" },
  hAxis: {
    title: "Total Population",
    minValue: 0,
  },
  vAxis: {
    title: "Province",
  },
};

const BarChartOptions2 = {
  title: "No. of users based on countries",
  // chartArea: { width: "50%" },
  hAxis: {
    title: "Total Population",
    minValue: 0,
  },
  vAxis: {
    title: "Country",
  },
};

export default function Analytics() {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  const [localLoader, setLocalLoader] = useState(true);
  const [updatedJSON, setUpdatedJSON] = useState();

  const [selectedAgeID, setSelectedAgeID] = useState();
  const [selectedAge, setSelectedAge] = useState();
  const [selectedProfID, setSelectedProfID] = useState();
  const [professions, setProfessions] = useState();
  const [activeCounty, setActiveCounty] = useState(null);
  const [selectedProf, setSelectedProf] = useState();

  const [totalInternational, setTotalInternational] = useState();
  const [totalNational, setTotalNational] = useState();
  const [totalLocal, setTotalLocal] = useState();

  const [internationalUsers, setInternationalUsers] = useState();
  const [nationalUsers, setNationalUsers] = useState();

  const partnerID = sessionStorage.getItem("partnerId");
  const currentYear = new Date().getFullYear();

  const componentRef = useRef();

  const [filterType, setFilterType] = useState();
  const [showYearDropdown, setShowYearDropdown] = useState(false);
  const [yearDropdownOptions, setYearDropdownOptions] = useState([]);
  const [selectedYear, setSelectedYear] = useState();

  const [selected, setSelected] = useState("National");
  const [showQuarterly, setShowQuarterly] = useState(false);
  const [selectedQuarter, setSelectedQuarter] = useState();
  const [showMonthly, setShowMonthly] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState();

  const [ageGroups, setAgeGroups] = useState([])

  const getAnalytics = async (
    ageID,
    profID,
    filterType,
    year,
    month,
    quarter
  ) => {
    try {
      const res = await getRequest(
        userServiceApi.getEngagementData(
          partnerID,
          ageID,
          profID,
          filterType,
          year,
          month,
          quarter
        )
      );
      if (res) {

        console.log('res', res);
        setTotalInternational(res?.data?.internationalUsers?.totalCount);
        setTotalNational(res?.data?.nationalUsers?.totalCount);
        setTotalLocal(res?.data?.localUsers?.totalCount);

        const tempinternationalUsers = [["Country", "No. of Users"]];
        const tempnationalUsers = [["State", "No. of Users"]];
        const tempupdatedJSON = {
          type: "FeatureCollection",
          features: [],
        };

        res?.data?.internationalUsers?.countryCount?.map((country) => {
          let temp = [];
          temp.push(country.country);
          temp.push(country.count);
          // internationalUsers.push(temp);
          tempinternationalUsers.push(temp);
        });

        res?.data?.nationalUsers?.nationalCount?.map((country) => {
          let temp = [];
          temp.push(country.state);
          temp.push(country.count);
          // nationalUsers.push(temp);
          tempnationalUsers.push(temp);
        });

        const populationData = res?.data?.localUsers?.countyCount;

        const updatedGeoJSON = geoJsonData.features.map((feature) => {
          // Get the county name from GeoJSON
          const countyName = feature.properties.ctyua_name[0];
          // Find the corresponding population data
          const populationInfo = populationData?.find(
            (population) => population.county === countyName
          );

          // If population data is found, update the GeoJSON properties
          if (populationInfo) {
            feature.properties.population = populationInfo.count;
          } else {
            // If county is not present in population data, set population to 0
            feature.properties.population = 0;
          }
          // updatedJSON?.features.push(feature);
          tempupdatedJSON?.features.push(feature);
          return feature;
        });

        setInternationalUsers(tempinternationalUsers);
        setNationalUsers(tempnationalUsers);
        setUpdatedJSON(tempupdatedJSON);

        setLocalLoader(false);
      }
    } catch (error) {
      toast.error("Failed to fetch engagement data")
    }
    finally {
      setLoader(false);
    }
  };

  const handleAgeCard = (ageGroupData) => {
    setSelectedProf();
    setSelectedProfID();

    if (selectedAgeID === ageGroupData.id) {
      setSelectedAgeID("");
      setSelectedAge('');
    }
    else {
      setSelectedAgeID(ageGroupData.id);
      setSelectedAge(ageGroupData.value);
      getProfessions(ageGroupData.id);
    }
  };

  const getProfessions = async (id) => {
    try {
      const response = await getRequest(userServiceApi.getProfessions(id));
      if (response) {
        setProfessions(response.data);
      }
    } catch (error) {
      toast.error("Failed to fetch professions")
    }
  };

  const getColor = (population) => {
    // Implement your own logic to set colors based on population ranges
    return population > 5000
      ? "#032034"
      : population > 1000
        ? "#053656"
        : population > 500
          ? "#074b79"
          : population > 200
            ? "#08619b"
            : population > 100
              ? "#0a76be"
              : population > 50
                ? "#0c8be1"
                : // population > 50 ? '#021523' :
                "#1e9ef3";
    // '#e8300c';
  };

  const renderChoroplethMap = () => {
    // Assume 'geoJsonData' is the GeoJSON data for UK counties
    // 'populationData' is the merged population data with GeoJSON data

    const onEachCounty = (county, layer) => {
      layer.on({
        mouseover: (e) => {
          const layer = e.target;
          layer.setStyle({ fillOpacity: 1 });

          const population = layer.feature.properties.population || "0";
          const popupContent = `
                    <b>${layer.feature.properties.ctyua_name}</b><br>
                    No. of people: ${population}
                  `;
          layer.bindPopup(popupContent).openPopup();

          setActiveCounty(layer);
        },
        mouseout: () => {
          if (activeCounty) {
            activeCounty.setStyle({ fillOpacity: 0.9 });
          }
          // activeCounty.closePopup();
        },
      });

      // Use the population data to set style or add popups for each county
      const population = county.properties.population; // Assuming 'name' contains the county name
      if (population >= 1) {
        // Customize styles based on population, for example:
        layer.setStyle({
          fillColor: getColor(population),
          weight: 2,
          color: getColor(population),
          fillOpacity: 0.7,
        });
      } else {
        layer.setStyle({
          fillColor: "#8c8a89",
          weight: 1,
          color: "#8c8a89",
          fillOpacity: 0.4,
        });
      }
    };

    return (
      <MapContainer
        className="map-component"
        center={[54.8, -4.6]}
        zoom={6}
        minZoom={5}
      // style={{ height: '450px', width: '70vw' }}
      >
        <TileLayer
          attribution=""
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {/* Dark mode */}
        {/* <TileLayer
                    // attribution='&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="http://cartodb.com/attributions">CartoDB</a>'
                    attribution=""
                    url='https://cartodb-basemaps-{s}.global.ssl.fastly.net/dark_all/{z}/{x}/{y}.png'
                /> */}
        <GeoJSON
          // data={geoJsonData.features}
          data={updatedJSON.features}
          onEachFeature={onEachCounty}
        />
      </MapContainer>
    );
  };

  const getYearsDropdown = () => {
    const currentYear = new Date().getFullYear();
    let yearsarray = [];
    for (let year = 2023; year <= currentYear + 20; year++) {
      yearsarray.push(year);
    }
    setYearDropdownOptions(yearsarray);
  };

  // const [csvData, setCSVData] = useState(null);
  const downloadCSV = (csvData) => {
    if (!csvData) return;

    const currentDate = new Date();
    const day = String(currentDate.getDate()).padStart(2, "0");
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const year = String(currentDate.getFullYear()).slice(-2);
    const filename = `Analytics_data_${day}-${month}-${year}.csv`;

    const blob = new Blob([csvData], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    // setTimeout(() => {
    //     toast.success("CSV downloaded");
    // }, 1000)
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };

  const handleCSVDownload = async () => {
    try {
      const res = await getRequest(
        userServiceApi.downloadEngagementCSV(
          partnerID,
          selectedAgeID,
          selectedProfID,
          ((filterType === "yearly" && selectedYear) ||
            (filterType === "monthly" && selectedMonth) ||
            (filterType === "quarterly" && selectedQuarter)) &&
          filterType,
          (filterType === "yearly" ||
            filterType === "monthly" ||
            filterType === "quarterly") &&
          selectedYear,
          filterType === "monthly" && selectedMonth,
          filterType === "quarterly" && selectedQuarter
        )
      );
      if (res) {
        const csvData = res.data;
        downloadCSV(csvData);
      }
    } catch (error) {
      toast.error("CSV couldn't be downloaded");
    }
  };

  const handleSelected = (value) => {
    setSelected(value);
  };

  useEffect(() => {
    const ageGroups = async () => {
      try {
        setLoader(true)
        const res = await getRequest(userServiceApi.getAgeGroups())
        setAgeGroups(res.data)
      } catch (error) {
        toast.error("Failed to fetch Age groups")
      }
      finally {
        setLoader(false)
      }
    }
    ageGroups()
  }, [])

  useEffect(() => {
    // if (selectedAge !== undefined) {
    getAnalytics(
      selectedAgeID,
      selectedProfID,
      ((filterType === "yearly" && selectedYear) ||
        (filterType === "monthly" && selectedMonth) ||
        (filterType === "quarterly" && selectedQuarter)) &&
      filterType,
      (filterType === "yearly" ||
        filterType === "monthly" ||
        filterType === "quarterly") &&
      selectedYear,
      filterType === "monthly" && selectedMonth,
      filterType === "quarterly" && selectedQuarter
    );
    setLocalLoader(true);
    // }
  }, [
    selectedAgeID,
    selectedProfID,
    selectedYear,
    selectedQuarter,
    selectedMonth,
  ]);

  useEffect(() => {
    getYearsDropdown();
  }, []);

  if (loader) {
    return (
      <div className="data-loader">
        <Spin className="loading-svg" tip="Loading" size="large" />
      </div>
    );
  } else {
    return (
      <div ref={componentRef} className="main-container" style={{ padding: "10px" }}>
        <div className="header-container">
          <div className="partner-heading">
            <img
              className="back-btn-arrow"
              src={leftArrow}
              onClick={() => {
                navigate("/admin");
                sessionStorage.removeItem("partnerId");
              }}
            />
            <p>Engagement</p>
          </div>
        </div>
        <div className="print-header">
          <p className="header">{`${sessionStorage.getItem("OrgName")} Engagement`}</p>
        </div>
        <div className="filter-box">
          <div className="filters-container-analytics">
            <div className="ages">
              <div className="age-cards">
                {
                  ageGroups.map((ageGroup) => {
                    return <div
                      key={ageGroup.id}
                      className={`card ${selectedAgeID === ageGroup.id ? "selected-age" : ""
                        }`}
                      onClick={() =>
                        handleAgeCard(ageGroup)
                      }
                    >
                      <p className="age-card-content">{ageGroup.value.replace(/\s+/g, "")
                      }</p>
                    </div>
                  })
                }

              </div>
            </div>
            <div className="profs">
              <div className="prof-cards add-filter-btns">
                {/* <Form layout="vertical"> */}
                <Form.Item
                  label="Profession"
                  colon={false}
                  className="term-select align-right-class"
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                >
                  <Select
                    allowClear
                    className="customSelect"
                    // placeholder={firstValue}
                    disabled={selectedAge ? false : true}
                    placeholder="Select Profession"
                    value={selectedProfID}

                    onChange={(profId) => {
                      const selected = professions.find(item => item?.id === profId);
                      setSelectedProfID(profId);
                      setSelectedProf(selected?.value);
                    }}
                    onClear={() => {
                      setSelectedProf();
                      setSelectedProfID();
                    }}
                  >
                    {professions &&
                      professions?.map((ageGroupData, i) => (
                        <Select.Option
                          key={ageGroupData?.id} // key for map 
                          value={ageGroupData?.id} // actual key
                        >
                          {ageGroupData?.value}
                        </Select.Option>
                      ))}
                  </Select>
                </Form.Item>
                <Form.Item className="term-select align-right-class" label="Term" colon={false}
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}>
                  <Select
                    allowClear
                    className="customSelect"
                    // placeholder={firstValue}
                    placeholder="Select Term"
                    value={filterType}
                    onChange={(e) => {
                      setFilterType(e);
                      if (e == "quarterly") {
                        setShowMonthly(false);
                        setSelectedMonth();
                        setSelectedYear();
                        setSelectedQuarter();
                        setShowYearDropdown(true);
                        setShowQuarterly(true);
                      } else if (e == "monthly") {
                        setSelectedMonth();
                        setSelectedYear();
                        setSelectedQuarter();
                        setShowYearDropdown(true);
                        setShowQuarterly(false);
                        setShowMonthly(true);
                      } else if (e == "yearly") {
                        setSelectedMonth();
                        setSelectedYear();
                        setSelectedQuarter();
                        setShowMonthly(false);
                        setShowQuarterly(false);
                        setShowYearDropdown(true);
                      }
                    }}
                    onClear={() => {
                      setFilterType();
                      setSelectedYear();
                      setSelectedMonth();
                      setSelectedQuarter();
                      setShowYearDropdown(false);
                      setShowMonthly(false);
                      setShowQuarterly(false);
                    }}
                    options={[
                      {
                        value: "yearly",
                        label: "Yearly",
                      },
                      {
                        value: "monthly",
                        label: "Monthly",
                      },
                      {
                        value: "quarterly",
                        label: "Quarterly",
                      },
                    ]}
                  ></Select>
                </Form.Item>
                {showYearDropdown && (
                  <Form.Item className="term-select align-right-class" label="Year" colon={false}
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}>
                    <Select
                      allowClear
                      className="customSelect"
                      // placeholder={firstValue}
                      placeholder="Select Year"
                      value={selectedYear}
                      onChange={(e) => {
                        setSelectedYear(e);
                      }}
                      onClear={() => {
                        setSelectedYear();
                        setSelectedMonth();
                        setSelectedQuarter();
                        setShowQuarterly(false);
                        setShowMonthly(false);
                        setShowYearDropdown(false);
                        setFilterType();
                      }}
                    >
                      {yearDropdownOptions?.length > 0 &&
                        yearDropdownOptions.map((year, i) => (
                          <Select.Option
                            disabled={year > currentYear ? true : false}
                            key={year}
                            value={year}
                          >
                            {year}
                          </Select.Option>
                        ))}
                    </Select>
                  </Form.Item>
                )}
                {showMonthly && (
                  <Form.Item className="term-select align-right-class" label="Month" colon={false}
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}>
                    <Select
                      allowClear
                      className="customSelect"
                      // placeholder={firstValue}
                      disabled={selectedYear ? false : true}
                      placeholder="Select Month"
                      value={selectedMonth}
                      onChange={(e) => {
                        setSelectedMonth(e);
                      }}
                      onClear={() => {
                        setSelectedMonth();
                        setSelectedYear();
                        // setFilterType();
                        // setShowMonthly(false);
                        // setShowYearDropdown(false);
                      }}
                      options={[
                        { value: "1", label: "January" },
                        { value: "2", label: "February" },
                        { value: "3", label: "March" },
                        { value: "4", label: "April" },
                        { value: "5", label: "May" },
                        { value: "6", label: "June" },
                        { value: "7", label: "July" },
                        { value: "8", label: "August" },
                        { value: "9", label: "September" },
                        { value: "10", label: "October" },
                        { value: "11", label: "November" },
                        { value: "12", label: "December" },
                      ]}
                    ></Select>
                  </Form.Item>
                )}
                {showQuarterly && (
                  <Form.Item className="term-select align-right-class" label="Quarter" colon={false}
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}>
                    <Select
                      allowClear
                      className="customSelect"
                      // placeholder={firstValue}
                      placeholder="Select Quarter"
                      value={selectedQuarter}
                      disabled={selectedYear ? false : true}
                      onChange={(e) => {
                        setSelectedQuarter(e);
                      }}
                      onClear={() => {
                        setSelectedQuarter();
                        // setFilterType();
                        setSelectedYear();
                        // setShowQuarterly(false);
                        // setShowYearDropdown(false);
                      }}
                      options={[
                        {
                          value: "1",
                          label: "Q1",
                        },
                        {
                          value: "2",
                          label: "Q2",
                        },
                        {
                          value: "3",
                          label: "Q3",
                        },
                        {
                          value: "4",
                          label: "Q4",
                        },
                      ]}
                    ></Select>
                  </Form.Item>
                )}
                {/* </Form> */}
              </div>
            </div>
          </div>
          {/* <div className="">
         
          </div> */}
        </div>
        <div className="filters-tags-container">
          <div>
            {selectedAge && (
              <Tag className="filter-tags">
                {selectedAge === "18"
                  ? "<18"
                  : selectedAge === "22"
                    ? "19-22"
                    : selectedAge === "37"
                      ? "23-37"
                      : selectedAge === "53"
                        ? "38-53"
                        : "54+"}
              </Tag>
            )}
            {selectedProf && <Tag className="filter-tags">{selectedProf}</Tag>}
          </div>
          <div>
            {selectedMonth && (
              <Tag className="filter-tags">
                {selectedMonth === "1"
                  ? "January"
                  : selectedMonth === "2"
                    ? "February"
                    : selectedMonth === "3"
                      ? "March"
                      : selectedMonth === "4"
                        ? "April"
                        : selectedMonth === "5"
                          ? "May"
                          : selectedMonth === "6"
                            ? "June"
                            : selectedMonth === "7"
                              ? "July"
                              : selectedMonth === "8"
                                ? "August"
                                : selectedMonth === "9"
                                  ? "September"
                                  : selectedMonth === "10"
                                    ? "October"
                                    : selectedMonth === "11"
                                      ? "November"
                                      : "December"}
              </Tag>
            )}
            {selectedQuarter && (
              <Tag className="filter-tags">{selectedQuarter}</Tag>
            )}
            {selectedYear && <Tag className="filter-tags">{selectedYear}</Tag>}
            {filterType && <Tag className="filter-tags">{filterType}</Tag>}
          </div>
        </div>

        <div className="Uk-users-count-container">
          <div className="users-content">
            {/* <div className="users-cards">
                            <p className="sub-header" style={{ marginLeft: "0px" }}>Total No. of Users</p>
                            <div className={`card ${showLocal ? 'local-selected' : 'local-default'}`} onClick={() => handleCard("local")}>
                                <p className="card-content text">LOCAL</p>
                                <p className="card-content number">{totalLocal}</p>
                                <p className="card-content text">No. of users</p>
                            </div>
                            <div className={`card ${showNational ? 'national-selected' : 'national-default'}`} onClick={() => handleCard("national")}>
                                <p className="card-content text">NATIONAL</p>
                                <p className="card-content number">{totalNational}</p>
                                <p className="card-content text">No. of users</p>
                            </div>
                            <div className={`card  ${showInternational ? 'international-selected' : 'international-default'}`} onClick={() => handleCard("international")}>
                                <p className="card-content text">INTERNATIONAL</p>
                                <p className="card-content number">{totalInternational}</p>
                                <p className="card-content text">No. of users</p>
                            </div>
                        </div> */}
            <div className="selection-and-share">
              <div className="selection-container">
                <Duration
                  options={["Local", "National", "International"]}
                  selected={handleSelected}
                />
                <div className="user-count">
                  <p className="total-count">
                    {selected === "Local"
                      ? totalLocal
                      : selected === "National"
                        ? totalNational
                        : totalInternational}
                  </p>
                  <div className="count-label">
                    <p>{`${selected === "Local"
                      ? `Local`
                      : selected === "National"
                        ? `National`
                        : `International`
                      }`}</p>
                    <p>No. of users</p>
                  </div>
                </div>
              </div>
              <div className="share-options">
                <div className="share-csv">
                  <Dropdown
                    trigger={["click"]}
                    placement="bottomRight"
                    arrow={false}
                    overlay={
                      <div
                        className="dropdown"
                        style={{
                          border: "1px solid #3067AE",
                          borderRadius: "4px",
                          backgroundColor: "#fff",
                          width: "190px",
                        }}
                      >
                        <div
                          style={{
                            padding: "10px",
                            borderBottom: "1px solid #f0f0f0",
                            cursor: "pointer",
                          }}
                        >
                          <div
                            className="dropdown-items"
                            style={{
                              display: "flex",
                              alignContent: "center",
                            }}
                            onClick={handleCSVDownload}
                          >
                            <FileExcelOutlined className="pdf-icon" />
                            <label
                              style={{ marginLeft: "10px", cursor: "pointer" }}
                            >
                              Download as CSV
                            </label>
                          </div>
                        </div>
                        <ReactToPrint
                          copyStyles={true}
                          content={() => componentRef.current}
                          // onAfterPrint={() => {
                          //     toast.success("PDF downloaded successfully")
                          // }}
                          trigger={() => {
                            return (
                              <div
                                style={{
                                  padding: "13px",
                                  borderBottom: "1px solid #f0f0f0",
                                  cursor: "pointer",
                                }}
                              >
                                <div
                                  className="dropdown-items"
                                  style={{
                                    display: "flex",
                                    alignContent: "center",
                                  }}
                                >
                                  <FilePdfOutlined className="pdf-icon" />
                                  <label
                                    style={{
                                      marginLeft: "10px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    Download as PDF
                                  </label>
                                </div>
                              </div>
                            );
                          }}
                        ></ReactToPrint>
                      </div>
                    }
                  >
                    {/* <img src={shareIcon} alt="" /> */}
                    <DownloadOutlined style={{ fontSize: '24px', color: '#3067ae' }} />
                  </Dropdown>
                </div>
                {/* <Divider type="vertical" className="divider" />
                <div className="download-pdf">
                  <img src={downloadIcon} alt="" onClick={handleCSVDownload} />
                </div> */}
              </div>
            </div>

            <div className="users-by-map">
              {selected === "Local" ? (
                <div className="charts">
                  {!localLoader && updatedJSON ? (
                    <div className="local-chart">
                      {Object.keys(updatedJSON)?.length === 0 && (
                        <div>Loading...</div>
                      )}
                      {Object.keys(updatedJSON)?.length > 0 &&
                        renderChoroplethMap()}
                      <div>
                        <div className="gradient-legend"></div>
                        <div className="text-legend">
                          <div className="start">
                            <p style={{ marginLeft: "0px" }}>less than 50</p>
                          </div>
                          <div className="end">
                            <p style={{ marginRight: "0px" }}>
                              greater than 5000
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="data-loader">
                      <Spin
                        className="loading-svg"
                        tip="Loading"
                        size="large"
                      />
                    </div>
                  )}
                </div>
              ) : selected === "National" ? (
                nationalUsers?.length > 1 ? (
                  <div className="charts">
                    <div className="geoChart">
                      <Chart
                        // className="geoChart"
                        className="gchart"
                        chartType="GeoChart"
                        width="100%"
                        // height="400px"
                        loader={true}
                        // data={data}
                        data={nationalUsers}
                        options={options}
                      />
                    </div>
                    <div className="barChart">
                      <Chart
                        // className="barChart"
                        className="gchart"
                        chartType="BarChart"
                        width="100%"
                        height="400px"
                        loader={true}
                        // data={data}
                        data={nationalUsers}
                        options={BarChartOptions}
                      />
                    </div>
                  </div>
                ) : (
                  <p className="sub-header" style={{textAlign:'center', margin: "50px 0"}}>No data available</p>
                )
              ) : internationalUsers?.length > 1 ? (
                <div className="charts">
                  {/* <p>Internationa</p> */}
                  <div className="geoChart">
                    <Chart
                      // className="geoChart"
                      className="gchart"
                      chartType="GeoChart"
                      // width="650px"
                      // height="400px"
                      width="100%"
                      // height="100%"
                      data={internationalUsers}
                      options={options2}
                    />
                  </div>
                  <div className="barChart">
                    <Chart
                      className="gchart"
                      chartType="BarChart"
                      width="100%"
                      height="400px"
                      data={internationalUsers}
                      options={BarChartOptions2}
                    />
                  </div>
                </div>
              ) : (
                <p className="sub-header" style={{textAlign:'center', margin: "50px 0"}}>No data available</p>
              )}

              {/* </div> */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
